import { render, staticRenderFns } from "./FirstTime.vue?vue&type=template&id=1bec10cc&scoped=true&"
import script from "./FirstTime.vue?vue&type=script&lang=js&"
export * from "./FirstTime.vue?vue&type=script&lang=js&"
import style0 from "./FirstTime.vue?vue&type=style&index=0&id=1bec10cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec10cc",
  null
  
)

export default component.exports